import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getLeads = async (endpoint, tableName, filters = {}) => {
  try {
    const url = `${baseUrl}${endpoint}`
    const { data } = await axios.get(url, {
      params: { table: tableName, ...filters }, // Pass filters for PK, SK, or EntityType
    })
    return data || []
  } catch (error) {
    console.error('Error fetching data:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useLeads = (enabled = false) => {
  const { data: leads, isLoading: isLeadsLoading, isError: isLeadsError } = useQuery({
    queryKey: ['leads'],
    queryFn: () => getLeads('/aws/leads', 'leads'),
    staleTime: Infinity, // Prevent the query from becoming stale
    gcTime: 1000 * 60 * 30, // Cache for 30 minutes
    refetchOnWindowFocus: false, // Prevent refetching when window regains focus
    refetchOnReconnect: false, // Prevent refetching when the network reconnects
    enabled,
  })
  return { leads, isLeadsLoading, isLeadsError }
}
